import { auth } from '../../Services/firebase';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, sendPasswordResetEmail } from 'firebase/auth';
import './login.css'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import google_icon from '../../resources/google-icon.png'
import { useState } from 'react';
import { BsEyeFill, BsEyeSlash } from "react-icons/bs";
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useNavigate } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import logo_name from '../../resources/Logo.svg'

function SignIn() {
    const [resetSent, setResetSent] = useState(false)
    const [needEmail, setNeedEmail] = useState(false)
    const [invalidEmail, setInvalidEmail] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const navigate = useNavigate();

    function goToPage(path) {
        navigate(path);
    }

    function regularLogin(e) {
        e.preventDefault();
        const email = document.getElementById('login_email_input').value;
        const password = document.getElementById('login_password_input').value

        signInWithEmailAndPassword(auth, email, password)
            .catch((error) => {
                const errorCode = error.code;
                if (error.code === 'auth/invalid-email') {
                    alert("The provided value for the email user property is invalid.")
                } else if (errorCode === 'auth/invalid-credential') {
                    alert("Invalid credential")
                } else {
                    alert("An unkown issue happened.")
                }
            });
    }

    function continueWithGoogle() {
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider)
            .catch((error) => {
                alert("An error occured while logging in the user.")
            });
    }

    const ColorButton = styled(Button)(({ theme }) => ({
        color: 'white',
        height: '60px',
        backgroundColor: '#235539',
        '&:hover': {
            backgroundColor: '#247e4b',
        },
    }));

    const GoogleButton = styled(Button)(({ theme }) => ({
        color: '#21201F',
        height: '55px',
        border: '1px solid #21201F',
        display: 'flex',
        '&:hover': {
            backgroundColor: '#21201f15',
            border: '1px solid #21201F',
        },
    }));

    function forgtoPassword() {
        const email = document.getElementById('login_email_input').value;
        if (email)
            sendPasswordResetEmail(auth, email)
                .then(() => {
                    // Password reset email sent!
                    // ..
                    setResetSent(true)
                    setNeedEmail(false)
                    setInvalidEmail(false)
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    // ..
                    if (errorCode === 'auth/invalid-email') {
                        setResetSent(false)
                        setNeedEmail(false)
                        setInvalidEmail(true)
                    }
                    console.log(errorCode)
                });
        else {
            setResetSent(false)
            setNeedEmail(true)
            setInvalidEmail(false)
        }
    }

    return (
        <div>
            <div className='login_div flex flex_column gap_20 justify_center'>
                <center>
                    <img className="logo-icon-login" alt="" src={logo_name} />
                </center>
                {/* <h4 className='login_header font_weight_700 font_size_28 text_align_center'>Welcome Back</h4> */}
                {resetSent ? <p className='login_reset_email_p'>An email has been sent to you!</p> : null}
                {needEmail ? <p>Email is required.</p> : null}
                {invalidEmail ? <p>Invalid email.</p> : null}

                <form onSubmit={regularLogin} className='flex flex_column gap_20 justify_center'>
                    <TextField id='login_email_input' label="Email Address" variant="outlined" color='primary'
                        type="email" name="email" required />

                    <FormControl variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Password*</InputLabel>
                        <OutlinedInput id='login_password_input' label="Password*" variant="outlined"
                            type={showPassword ? 'text' : 'password'}
                            required
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <BsEyeSlash /> : <BsEyeFill />}
                                    </IconButton>
                                </InputAdornment>
                            } />
                    </FormControl>

                    <p className={(!resetSent ? 'cursor_pointer' : '') + ' login_forgot_password width_fit_content'} onClick={() => !resetSent ? forgtoPassword() : null}>Forgot password?</p>

                    <ColorButton variant="contained" type="submit">Continue</ColorButton>
                </form>

                <p className='text_align_center'>Don't have an account? {' '}
                    <span className='login_forgot_password cursor_pointer width_fit_content' onClick={() => goToPage('/sign-up')}>Sign up</span>
                </p>

                <div className='login_or_div align_center gap_12'>
                    <div className='login_or_line_div'></div>
                    <p className='font_size_12'>OR</p>
                    <div className='login_or_line_div'></div>
                </div>

                <GoogleButton variant="outlined" onClick={continueWithGoogle}
                    startIcon={<img src={google_icon} width={20} />}>Continue with Google</GoogleButton>

            </div >
        </div>
    )
}

export default SignIn
